import { FC, useMemo } from "react";
import { Backdrop, Box, Typography } from "@mui/material";
import CommonGifAnimation from "../../components/CustomGifAnimation/CommonGifAnimation";
import { T_AnimationData } from "../../globalTypes/GlobalTypes";
import LoaderGif from "../../assets/gif/Coffee_Loader.json";
import { Colors } from "../../styles/constant";

type T_LoaderOverlayProps = {
  zIndex: number;
  heading: string;
};

const LoaderOverlay: FC<T_LoaderOverlayProps> = ({ zIndex, heading }) => {
  const backdropStyles = useMemo(
    () => ({
      height: "100%",
      width: "100%",
      padding: "0rem",
      margin: "0rem",
      zIndex,
      backgroundColor: "white",
    }),
    [zIndex],
  );

  return (
    <Backdrop open={true} style={backdropStyles}>
      <Box>
        <CommonGifAnimation
          width={"9.375rem"}
          animationData={LoaderGif as T_AnimationData}
        />
        <Typography marginTop={"2rem"} variant="h3" color={Colors.textblack}>
          {heading}
        </Typography>
        <Typography
          marginTop={"1rem"}
          variant="h5"
          color={Colors.descriptionGray}
        >
          This will be done before your coffee brews
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoaderOverlay;
